import Api from '@/services/api';
import {removeEmptyParams, transformDownloadResponse} from '@utils';
import moment from 'moment';
import contentDisposition from 'content-disposition';

export default {
  exportReservations(filter) {
    return Api()
      .get('/reservations/export', {
        responseType: 'blob',
        transformResponse: [transformDownloadResponse],
        params: removeEmptyParams(filter),
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        let fileName = contentDisposition.parse(response.headers['content-disposition']).parameters.filename;
        link.setAttribute('download', fileName);
        link.click();
        window.URL.revokeObjectURL(url);
      });
  },
  exportReservationByMandat(filter) {
    return Api()
      .get('/reservations/export/mandat', {
        params: removeEmptyParams(filter),
        responseType: 'blob',
        transformResponse: [transformDownloadResponse],
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        let fileName = contentDisposition.parse(response.headers['content-disposition']).parameters.filename;
        link.setAttribute('download', fileName);
        link.click();
        window.URL.revokeObjectURL(url);
      });
  },
  formatRes(data) {
    if (data.date) {
      data.date = moment(data.date).utc(true).toDate();
    }
    return data;
  },
};
